<template>
  <div class="app-spinner">
    <hollow-dots-spinner :animation-duration="1000" :dot-size="size" :dots-num="3" :color="color" />
  </div>
</template>

<script>
import { HollowDotsSpinner } from 'epic-spinners'

export default {
  name: 'AppSpinner',

  components: {
    HollowDotsSpinner,
  },
  props: {
    size: {
      type: Number,
      default: 15,
    },
    color: {
      type: String,
      default: '#9b9dd1',
    },
  },
}
</script>

<style scoped>
.hollow-dots-spinner {
  margin: 0 auto;
}
</style>
